<template>
  <div style="margin-top: 86px">
    <div class="product-type-empty" v-if="!finished">
    </div>
    <div class="product-type" v-if="finished">
      <div class="product-type-item" v-for="item in categoryProducts" :key="item.productSeriesId">
        <div class="product-type-top">{{item.productSeriesName}}</div>
        <el-row  style="padding-top:20px">
          <el-col :span="6" v-for="item2 in item.productList" :key="item2.productId">
            <router-link :to="{path:item2.productRouter}">
              <el-image
                      style="width: 200px;height: 200px;border: 1px solid #d9d9d9;"
                      :src="item2.imgUrl"
                      fit="contain"></el-image>
              <p class="product-type-name">{{item2.productName}}</p>
            </router-link>
          </el-col>
          <el-col :span="6">
          </el-col>
          <el-col :span="6">
          </el-col>
          <el-col :span="6">
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'ProductType',
  data() {
    return {
      finished: false,
      productCategoryRouter: '',
      productCategoryId: '',
      categoryProducts: []
    }
  },
  methods: {
    initProducts() {
      this.finished = false;
      let url = '/product/listCategoryProduct?productCategoryId=' + this.productCategoryId;
      this.getRequest(url).then(resp => {
        if (resp.obj) {
          this.categoryProducts = resp.obj.productSeriesList;
          if(this.categoryProducts && this.categoryProducts.length > 0){
            var _this = this;
            _this.categoryProducts.forEach(row1 => {
              if(row1.productList && row1.productList.length > 0){
                row1.productList.forEach(row2 => {
                  var imgUrl = _this.baseUrl + '/pic/viewPic?picId=' + row2.productCoverPicId;
                  row2.imgUrl = imgUrl;
                  row2.productRouter = resp.obj.productCategoryRouter + '/' + row2.productId;
                })
              }
            })
          }
          this.finished = true;
        }
      });
    }
  },
  mounted() {
    this.initProducts();
  },
  created() {
    this.categoryRouter = this.$route.params.categoryRouter;
    this.productCategoryId = this.$route.query.productCategoryId;
  },
  /*监测路由的变化 */
  watch: {
    $route(to, from) {
      this.categoryRouter = this.$route.params.categoryRouter;
      this.productCategoryId = this.$route.query.productCategoryId;
      this.initProducts();
    }
  }
}
</script>

<style src="../../assets/css/productType.css" scoped>


</style>
